import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const importGrammarCurriculumV1DataSchemaDefinition = z.object({
  points: z.number().int().min(0),
  items: z.number().int().min(0),
  examItems: z.number().int().min(0),
});

export const importGrammarCurriculumV1DataSchema: typeof importGrammarCurriculumV1DataSchemaDefinition =
  importGrammarCurriculumV1DataSchemaDefinition;

export type IImportGrammarCurriculumV1Data = z.infer<typeof importGrammarCurriculumV1DataSchema>;

export const importGrammarCurriculumV1ResponseSchema: z.ZodSchema<
  IAPI<IImportGrammarCurriculumV1Data>
> = createApiResponseSchema(importGrammarCurriculumV1DataSchema) as z.ZodSchema<
  IAPI<IImportGrammarCurriculumV1Data>
>;

export type IImportGrammarCurriculumV1Response = IAPI<IImportGrammarCurriculumV1Data>;
